import script from "./OrderTracking.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTracking.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__